module.exports = __webpack_public_path__ + "img/logo2@2x.6b9a93da.png";